<template>
  <div id="aqt_content " class="news_details">
    <div class="details">
      <p class="new_title"> {{ details.title }}</p>
      <p class="common adminis">后台管理员</p>
      <p class="common from">{{ details.author }}</p>
      <div class="details_content">
        <p class="paragraph" v-html="details.content"></p>
        <!--            <img :src="details.picname" class="content_img"/>-->
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'

Vue.prototype.$http = axios
export default {
  data() {
    return {
      details: [],
    }
  },
  mounted() {
    const that = this
    const url = 'http://admin.aqitai.com/Home/Index/NewsInfo?id=' + that.$route.query.id
    axios.get(url).then(response => {
      const result = response.data.data
      this.details = result
      console.log(result)
    }).catch(error => {
      alert('当前网络不佳...')
    })
  }
}
</script>

<style scoped lang="less">
#aqt_content {
}

.news_details {
  padding-bottom: 4rem;
  width: 90%;
  height: auto;
  margin-left: 5%;

  .details {
    padding-top: 8rem;

    .new_title {
      display: inline-block;
      width: 100%;
      height: 3rem;
      font-size: 1.3rem;

      letter-spacing: 0.2rem;
      color: #fff;
      margin: 0 auto;
      margin-left: 4%;
    }

    .common {
      display: inline-block;
      margin-top: 1rem;
      color: #D3DFFF;
      font-size: 0.8rem;
      margin-bottom: 2rem;
    }

    .adminis {
      margin-left: 2%;
    }

    .from {
      margin-left: 7%;
    }

    .details_content {
      /deep/ .paragraph p {
        font-size: 1rem;
        color: #D3DFFF;
        letter-spacing: 0.1rem;
        background-color: #1D3662;
        margin-left: 2%;
      }
    ;

      /deep/ p img {
        width: 102%;
        height: 17rem;
        margin-left: -2%;
      }
    }
  }


}

</style>
